import PropTypes from "prop-types"
import React from "react"
import { AiOutlineDelete } from "react-icons/ai"
import styled from "styled-components"

import FloatingButton from "../FloatingButton"

// ----------------------------------------------------------------------------

function _DeleteButton(props) {
    // -------------------------------------
    // Props destructuring
    // -------------------------------------

    const { className, onClick } = props

    // -------------------------------------
    // Hooks (e.g. useState, useMemo ...)
    // -------------------------------------

    // -------------------------------------
    // Effects
    // -------------------------------------

    // -------------------------------------
    // Component functions
    // -------------------------------------

    // -------------------------------------
    // Component local variables
    // -------------------------------------

    return (
        <FloatingButton onClick={onClick} className={`${className}`}>
            <AiOutlineDelete className="icn" />
        </FloatingButton>
    )
}

// ----------------------------------------------------------------------------
// Component PropTypes and default props
// ----------------------------------------------------------------------------

_DeleteButton.propTypes = {
    className: PropTypes.string.isRequired,
    onClick: PropTypes.func,
}

_DeleteButton.defaultProps = {}

// ----------------------------------------------------------------------------

const DeleteButton = styled(_DeleteButton)`
    & {
        .icn {
            font-size: 25px;
            color: ${({ theme }) => theme.colors.error};
        }
    }
`
// ----------------------------------------------------------------------------

export default DeleteButton
